import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Grid, MenuItem, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import * as z from "zod";
import { PasswordField } from "./index.js";
export const FormFields = ({ schema, label: getLabel, enumLabel, error, register, autoFocus, control, }) => (_jsx(_Fragment, { children: Object.keys(schema.shape).map((key, index) => {
        const value = schema.shape[key.toString()];
        const errorText = error(key);
        const formControlProps = {
            autoFocus: autoFocus && index === 0,
            error: !!errorText,
            helperText: errorText,
            fullWidth: true,
            label: getLabel(key),
        };
        if (value instanceof z.ZodNativeEnum) {
            return (_jsx(Grid, { item: true, xs: 12, sm: 6, children: _jsx(Controller
                // @ts-ignore
                , { 
                    // @ts-ignore
                    name: key, control: control, render: ({ field }) => (_jsx(TextField, { ...formControlProps, select: true, SelectProps: {
                            ...field,
                            value: field.value === undefined ? "" : field.value,
                        }, children: Object.entries(value._def.values).map(([label, value]) => typeof value === "number" && (_jsx(MenuItem, { value: value, children: enumLabel(key, label) }, label))) })) }) }, key.toString()));
        }
        const { ref: inputRef, ...inputProps } = register(key);
        const props = {
            ...inputProps,
            ...formControlProps,
            inputRef,
        };
        return (_jsx(Grid, { item: true, xs: 12, sm: 6, children: key === "password" ? (_jsx(PasswordField, { ...props })) : (_jsx(TextField, { ...props })) }, key.toString()));
    }) }));
//# sourceMappingURL=FormFields.js.map